<template>
  <fieldset>
    <legend :class="hideLegend ? 'visually-hidden' : ''">{{ legend }}</legend>
    <ul>
      <li v-for="facet in sortedFacets" :key="facet.value">
        <label
          :class="['filter', { active: selectedList.includes(facet.value) }]"
        >
          <input
            type="checkbox"
            :id="facet.value"
            :value="facet.value"
            :checked="selectedList.includes(facet.value)"
            name="facet"
            @change="updateSelected(facet.value)"
            @click="(event) => onClick(event, facet.value)"
          />
          <span>{{ getText(facet.value) }}</span>
        </label>
      </li>
    </ul>
  </fieldset>
</template>

<script>
import Sok from "common/js/script/sok";

export default {
  name: "SearchFacetsFieldset",
  props: {
    legend: String,
    facets: Array,
    selectedList: Array,
    facetName: String,
    texts: Object,
    hideLegend: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    sortedFacets() {
      if (!this.facets || this.facets.length < 2) {
          return this.facets;
      }
      if (this.facetName === "utb_tillfallen/starttermin") {
        return this.facets.sort((a, b) => {
          const terms = { vt: 0, st: 1, ht: 2 };
          const aValue = parseInt(a.value.substring(2));
          const bValue = parseInt(b.value.substring(2));
          const aTerm = terms[a.value.substring(0, 2)];
          const bTerm = terms[b.value.substring(0, 2)];
          if (aValue === bValue) {
            return aTerm - bTerm;
          }
          return aValue - bValue;
        });
      } else {
        return this.facets.sort((a, b) => a.value.localeCompare(b.value, "sv"));
      }
    },
  },
  methods: {
    updateSelected(selected) {
      if (!this.selectedList.includes(selected)) {
        this.selectedList.push(selected);
      } else {
        const index = this.selectedList.indexOf(selected);
        if (index > -1) {
          this.selectedList.splice(index, 1);
        }
      }
      // Emitera alla valda värden för facetten
      this.$emit("facetSelected", [...this.selectedList], this.facetName);
    },
    onClick(event, selected) {
      // Custom click handling if needed
    },
    getText(key) {
      const cleanedFacetName = this.facetName.replace("utb_tillfallen/", "");
      return Sok.getText(cleanedFacetName, key, this.texts);
    },
  },
};
</script>
